module.exports = __webpack_public_path__ + "assets/img/KeyReport_001.b298b0f2-ps.jpg";